// #region Banner Slider
function initBannerSlidersSwiper(bannerSlider) {
    let isAutoplay = true;
    let timeout = 3000;
    const timeoutValue = bannerSlider.querySelector(".banner-slider__wrapper").getAttribute("data-autoplay-timeout");

    if (timeoutValue !== null) {
        if (timeoutValue == 0) {
            isAutoplay = false;
        } else {
            timeout = timeoutValue;
        }
    }

    const swiper = new Swiper(".swiper[data-swiper-id='" + bannerSlider.getAttribute("data-swiper-id") + "']", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            addIcons: false
        },
        autoplay: {
            delay: timeout
        },
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
}
// #endregion

// #region Cards Slider
function initCardsSections() {
    let cardsSections = document.querySelectorAll('section.cards-slider .cards-slider__cards:not(.-initialized)');
    if (cardsSections !== undefined && cardsSections !== null && cardsSections.length > 0) {
        cardsSections.forEach((section) => {

            var actionButtonWrapper = null;
            var actionButtonPrevious = null;
            var actionButtonNext = null;
            var cards = null;

            initCards();

            if (cards.length == 0) return;
            if (cards.length == 1) section.classList.add("-single-card");

            actionButtonWrapper = section.querySelector('.cards__actions');
            actionButtonPrevious = actionButtonWrapper.querySelector('.actions__previous button');
            actionButtonNext = actionButtonWrapper.querySelector('.actions__next button');

            actionButtonPrevious.addEventListener('click', () => {
                movePositionCards('prev', cards)
            })
            actionButtonNext.addEventListener('click', () => {
                movePositionCards('next', cards)
            })

            initCardsIndicators(cards);

            let firstIndicator = section.querySelector('.actions__indicator > div:first-of-type');
            if (firstIndicator) firstIndicator.classList.add('-active');

            dragCards();

            function initCardsIndicators(cards) {
                let indicatorsWrapper = section.querySelector('.actions__indicator');
                let indicators = indicatorsWrapper.querySelectorAll('div');
                cards.forEach((item => {
                    let newIndicator = document.createElement('div');
                    newIndicator.classList.add('indicator', '-dot');
                    indicatorsWrapper.appendChild(newIndicator);
                }))

                let i = 1;

                indicators.forEach((item) => {
                    item.setAttribute('data-position', i)
                    i++;
                })
            }

            function initCards() {
                cards = section.querySelectorAll('.cards__item');
                initPositionCards(cards);

                section.classList.add("-initialized");
            }

            function initPositionCards(array) {
                let i = array.length;
                let j = 0;

                array.forEach((item) => {
                    item.setAttribute("data-position", j + 1);
                    item.style.transfrom = "translateX(0)";
                    if (window.innerWidth < 400) {
                        item.style.transform = "translateX(" + j * 15 + "px) scale(" + (1 - (j * 0.05)) + ")";
                    } else {
                        item.style.transform = "translateX(" + j * 20 + "px) scale(" + (1 - (j * 0.05)) + ")";
                    }
                    item.style.zIndex = i;
                    i--;
                    j++;
                })
            }

            function movePositionCards(action, array) {
                let firstCard = array[0];
                let lastCard = array[array.length - 1];
                let firstIndicator = section.querySelector('.indicator:first-of-type');
                let lastIndicator = section.querySelector('.indicator:last-of-type');
                let activeIndicator = section.querySelector('.indicator.-active');
                let nextIndicator = activeIndicator.nextElementSibling;
                let previousIndicator = activeIndicator.previousElementSibling;

                switch (action) {
                    case 'prev':
                        firstCard.before(lastCard);
                        initCards();
                        activeIndicator.classList.remove('-active');
                        previousIndicator == null
                            ? lastIndicator.classList.add('-active')
                            : previousIndicator.classList.add('-active')
                        break;

                    case 'next':
                        lastCard.after(firstCard);
                        initCards();
                        activeIndicator.classList.remove('-active');
                        nextIndicator == null
                            ? firstIndicator.classList.add('-active')
                            : nextIndicator.classList.add('-active')
                        break;
                    default:
                        console.log('error')
                }

                dragCards();
            }

            function dragCards() {
                let cards = section.querySelectorAll('.cards__item');
                let dragStartX = 0;
                let isItemDragging = null;
                let device = getDeviceType();
                item = cards[0];

                let eventStart, eventDrag, eventEnd;

                if (device !== "desktop") {
                    eventStart = "touchstart";
                    eventDrag = "touchmove";
                    eventEnd = "touchend";
                } else {
                    eventStart = "dragstart";
                    eventDrag = "dragover";
                    eventEnd = "dragend";
                }

                item.addEventListener(eventStart, (e) => {
                    device == "desktop" ? dragStartX = e.clientX : dragStartX = e.changedTouches[0].clientX;
                    isItemDragging = true;
                })

                item.addEventListener(eventDrag, (e) => {
                    if (isItemDragging) {
                        let offsetX
                        device == "desktop" ? offsetX = e.clientX - dragStartX : offsetX = e.changedTouches[0].clientX - dragStartX;
                        if (offsetX > 100) {
                            offsetX = 100;
                        } else if (offsetX < -100) {
                            offsetX = -100;
                        }
                        requestAnimationFrame(() => {
                            item.style.transform = `translateX(${offsetX}px)`;
                        })
                    }
                })

                item.addEventListener(eventEnd, () => {
                    isItemDragging = false;

                    setTimeout(() => {
                        item.style.transform = 'translateX(0)'
                        movePositionCards('next', cards);
                    }, 100)
                })
            }
        })
    }
};
function initSliderSections() {
    let sliderSections = document.querySelectorAll('section.cards-slider:not(.-autoplay) .cards-slider__slider');
    if (sliderSections !== undefined && sliderSections !== null && sliderSections.length > 0) {
        sliderSections.forEach((item) => {
            let slider = item.querySelector('.cards-slider__wrapper .slider__wrapper');
            if (slider !== null) {
                if (isSliderOverflown(slider)) {
                    slider.classList.add("swiper-wrapper");
                }
            }
        })
    }
}
function initSliderSwiper(sliderSwiper) {
    if (sliderSwiper.classList.contains("-insta")) return;

    const swiper = new Swiper(sliderSwiper, {
        centerInsufficientSlides: true,
        centerSlide: true,
        loop: true,
        spaceBetween: 40,
        slidesPerView: "auto",
        pagination: {
            el: ".swiper-pagination"
        },
        breakpoints: {
            1: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: "auto",
            },
            900: {
                centeredSlides: false
            }
        }
    })
}

function isSliderOverflown(slider) {
    const items = slider.querySelectorAll(".slider__item");
    const sliderStyle = getComputedStyle(slider);
    const sliderWidth = slider.clientWidth - parseInt(sliderStyle.paddingRight) - (parseInt(sliderStyle.gap) * (items.length - 1));
    let itemsWidth = 0;
    items.forEach(item => {
        itemsWidth += item.clientWidth;
    })

    return itemsWidth > sliderWidth;
}
// #endregion

// #region Products Slider
function initProductsSliderSwiper(swiperElement) {
    let slidesPerView = "auto";

    if (swiperElement.getAttribute("data-nb-slides-per-view")) {
        slidesPerView = parseInt(swiperElement.getAttribute("data-nb-slides-per-view"));
    }

    const swiper = new Swiper(swiperElement, {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        centerInsufficientSlides: true,
        breakpoints: {
            640: {
                slidesPerView,
                spaceBetween: 30,
                centeredSlides: false
            }
        }
    })
}
// #endregion

// #region Subsections Entries
function initSubsectionsEntries() {
    let subsectionsEntries = document.querySelectorAll('section.subsections-entries');
    if (subsectionsEntries !== null && subsectionsEntries !== undefined && subsectionsEntries.length > 0) {
        subsectionsEntries.forEach((subsection) => {
            let subsectionsTitlesWrapper = subsection.querySelector('.subsections-entries__titles');
            let subsectionsTitles = subsectionsTitlesWrapper.querySelectorAll('.titles__item');
            subsectionsTitles.forEach((item) => {
                let el = item.children[0]
                let elIdSubsection = el.getAttribute('data-subsection');
                item.addEventListener('click', () => {
                    subsectionsTitles.forEach((title) => { title.children[0].classList.remove('-active') })
                    el.parentNode.classList.add('-title-active')
                    el.classList.add('-active')
                    let subsectionsContent = subsection.querySelectorAll('.content__item')
                    let subsectionContent = subsection.querySelector('.content__item[data-subsection="' + elIdSubsection + '"]')

                    subsectionsContent.forEach((elem) => {
                        elem.classList.contains('-active') ? elem.classList.remove('-active') : '';
                    })

                    subsectionContent.classList.add('-active');
                    const paddingLeft = getComputedStyle(subsection)["paddingLeft"].replace('px', '');
                    subsectionsTitlesWrapper.scrollTo(el.offsetLeft - paddingLeft, 0);
                    LoadListenerItemSlider('subsections-entries__content .content__item.-active .item__wrapper');
                })
            })

            LoadListenerItemSlider('subsections-entries__titles');
            LoadListenerItemSlider('subsections-entries__content .content__item.-active .item__wrapper');
        })
    }
}
// #endregion

// #region Entries List
function initEntriesList() {
    let entriesList = document.querySelectorAll('section.entries-list');
    if (entriesList !== undefined && entriesList !== null && entriesList.length > 0) {
        LoadListenerItemSlider('entries-list__wrapper');
        entriesList.forEach((list) => {
            const buttons = list.querySelectorAll(".button");
            buttons.forEach((button) => {
                const href = button.getAttribute("href")
                if (href && href[0] == "#") {
                    const events = ["touchend", "click"];
                    events.forEach((evt) => {
                        button.addEventListener(evt, function (event) {
                            event.preventDefault();
                            const target = document.querySelector(href);
                            if (target !== undefined) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        })
                    })
                }
            })

        })
    }
}
// #endregion

// #region Simple Images
function initSimpleImagesSwiper(swiperSection) {
    const swiper = new Swiper(swiperSection, {
        slidesPerView: "auto",
        spaceBetween: 16,
    })
}
// #endregion

// #region Grid Pictures

function initGridPicturesSlider() {
    let sliders = $("section.grid-pictures .content__row:not(.-loaded)");
    sliders.each((index, item) => {
        if (item.classList.contains("-loaded")) return;

        let slider = $(item);
        let sliderId = index;
        let imagesWrapper = slider.find(".row__item.-image");
        let descriptionsWrapper = slider.find(".row__item.-description");
        let images = imagesWrapper.find(".item__wrapper");
        let descriptions = descriptionsWrapper.find(".item__wrapper");

        if (images.length > 1 && descriptions.length > 1) {
            slider.addClass("-slider");
            slider.attr("data-slider", sliderId);

            let dotsWrapper = slider.find(".item__dots");

            images.each((index, image) => {
                image = $(image);
                image.attr("data-position", index + 1);
                index == 0 ? image.addClass("-active") : "";

                let dot = document.createElement("div");
                $(dot).addClass("dots__item");
                $(dot).attr("data-slider", sliderId);
                $(dot).attr("data-position", index + 1);
                dotsWrapper.append($(dot));

                index == 0 ? $(dot).addClass("-active") : "";
            });

            descriptions.each((index, description) => {
                description = $(description);
                description.attr("data-position", index + 1);
                index == 0 ? description.addClass("-active") : "";
            });

            let controls = slider.find(".item__controls [data-action]");
            controls.each((index, button) => {
                button = $(button);
                button.attr("data-slider", sliderId);
            });
        }

        slider.addClass('-loaded');
    });

    initGridPictureSliderDrag();
}

function slideGridPicturesSlider(sliderId, action) {
    let slider = $('.content__row[data-slider="' + sliderId + '"]');
    let images = slider.find(".row__item.-image .item__wrapper");
    let descriptions = slider.find(".row__item.-description .item__wrapper");
    let dots = slider.find(".dots__item");

    if (images.length > 1 && descriptions.length > 1) {
        let activeImage = images.filter(".-active"),
            activeImagePosition = activeImage.data("position"),
            activeDescription = descriptions.filter(".-active"),
            activeDescriptionPosition = activeDescription.data("position"),
            activeDot = slider.find(".dots__item.-active"),
            activeDotPosition = activeDot.data("position"),
            nextImagePosition,
            nextDescriptionPosition,
            nextDotPosition;

        if (action == "next") {
            if (
                activeImagePosition == images.length ||
                activeDescriptionPosition == descriptions.length
            ) {
                // Si on arrive à la fin de la boucle on repart au début
                nextImagePosition = 1;
                nextDescriptionPosition = 1;
                nextDotPosition = 1;
            } else {
                nextImagePosition = activeImagePosition + 1;
                nextDescriptionPosition = activeDescriptionPosition + 1;
                nextDotPosition = activeDotPosition + 1;
            }
        } else if (action == "prev") {
            if (activeImagePosition == 1 || activeDescriptionPosition == 1) {
                // Si on arrive au début de la boucle on repart à la fin
                nextImagePosition = images.length;
                nextDescriptionPosition = descriptions.length;
                nextDotPosition = dots.length;
            } else {
                nextImagePosition = activeImagePosition - 1;
                nextDescriptionPosition = activeDescriptionPosition - 1;
                nextDotPosition = activeDotPosition - 1;
            }
        }

        let nextImage = images.filter(
            '[data-position = "' + nextImagePosition + '"]'
        ),
            nextDescription = descriptions.filter(
                '[data-position = "' + nextDescriptionPosition + '"]'
            ),
            nextDot = dots.filter('[data-position = "' + nextDotPosition + '"]');

        activeImage.removeClass("-active");
        activeDescription.removeClass("-active");
        activeDot.removeClass("-active");

        nextImage.addClass("-active");
        nextDescription.addClass("-active");
        nextDot.addClass("-active");
    }
}

function goToSlideGridPictureSlider(sliderId, slide) {
    let slider = $('.grid-pictures .content__row.-slider[data-slider="' + sliderId + '"]')
    let activeImage = slider.find('.row__item.-image .item__wrapper.-active');
    let activeDescription = slider.find('.row__item.-description .item__wrapper.-active');
    let activeDot = slider.find('.row__item.-description .item__dots .dots__item.-active');
    let newImage = slider.find('.row__item.-image .item__wrapper[data-position="' + slide + '"]')
    let newDescription = slider.find('.row__item.-description .item__wrapper[data-position="' + slide + '"]')
    let newDot = slider.find('.row__item.-description .item__dots .dots__item[data-position="' + slide + '"]')

    activeImage.removeClass('-active');
    activeDescription.removeClass('-active');
    activeDot.removeClass('-active');

    newImage.addClass('-active');
    newDescription.addClass('-active');
    newDot.addClass('-active');
}

function initGridPictureSliderDrag() {
    let draggableElements = $(".content__row.-slider .row__item");
    let dragStartPosition = 0;
    let dragEndPosition = 0;
    let slider = draggableElements.closest(".content__row.-slider");
    let sliderId = slider.data("slider");
    let events = {};
    let deviceType = getDeviceType();
    if (deviceType == "desktop") {
        events.start = "mousedown";
        events.end = "mouseup";
    } else {
        events.start = "touchstart";
        events.end = "touchend";
    }
    draggableElements.on(events.start, (e) => {
        if (deviceType == "desktop") {
            dragStartPosition = e.pageX;
        } else {
            dragStartPosition = e.originalEvent.touches[0].pageX;
        }
    });
    if (deviceType == "desktop") {
        draggableElements.on(events.end, (e) => {
            dragEndPosition = e.pageX;
            // Si le slide est de - de 50px on ne fait rien (si l'utilisateur ne fait pas exprès de slider OU pour éviter les conflits si on clique sur un bouton)
            if (Math.abs(dragStartPosition - dragEndPosition) > 50) {
                if (dragStartPosition - dragEndPosition > 0) {
                    slideGridPicturesSlider(sliderId, "next");
                } else {
                    slideGridPicturesSlider(sliderId, "prev");
                }
            }
        });
    } else {
        // On ne peut pas utiliser seulement touchend car l'event ne renvoie pas les coordonnées du touch, on est obigés de passer par touchmove
        draggableElements.on("touchmove", (e) => {
            dragEndPosition = e.originalEvent.touches[0].pageX;
        });
        draggableElements.on("touchend", (e) => {
            // Si on clique sur un bouton on s'arrête là || Si on ne slide pas dragEnd est à 0 donc ça va slider en arrière -> pour éviter ça, si aucun slide, on s'arrète aussi
            if (
                e.target == slider.find(".controls__prev")[0] ||
                e.target == slider.find(".controls__next")[0] ||
                dragEndPosition == 0
            ) {
                return;
            }
            if (Math.abs(dragStartPosition - dragEndPosition) > 50) {
                if (dragStartPosition - dragEndPosition > 0) {
                    slideGridPicturesSlider(sliderId, "next");
                } else {
                    slideGridPicturesSlider(sliderId, "prev");
                }
            }
        });
    }
}

// #endregion

document.addEventListener("SwiperLoaded", () => {
    //initBannerSliders();
    initCardsSections();
    initSliderSections();
    //initProductsSlider();
    initSubsectionsEntries();
    initEntriesList();
    //initSimpleImages();
    initGridPicturesSlider();
    //initPictureProductsSlider();
    onLoadScrollToElement();
})


$(document).ready(() => {
}).on("click", ".item__controls [data-action]", function (e) {
    let action = $(e.target).data("action");
    let slider = $(e.target).data("slider");
    slideGridPicturesSlider(slider, action);
}).on('click', '.dots__item[data-slider]', function (e) {
    let dotClicked = $(e.target);
    let sliderId = dotClicked.data("slider")
    let slideToGo = dotClicked.data('position')
    goToSlideGridPictureSlider(sliderId, slideToGo)
})

function isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

function getDeviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return "mobile";
    }
    return "desktop";
}

function isMobile() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera, 'http://detectmobilebrowser.com/mobile');
    return check;
}

function LoadListenerItemSlider(className) {
    let items = document.querySelectorAll('.' + className);
    if (items !== undefined && items !== null && items.length > 0) {
        items.forEach((item) => {
            if (isOverflown(item)) {
                const slider = item;
                slider.classList.add('-overflown');

                //if (!isMobile()) {
                if (slider != null) {
                    let isDown = false;
                    let startX;
                    let scrollLeft;

                    slider.addEventListener('mousedown', (e) => {
                        isDown = true;
                        slider.classList.add('active');
                        startX = e.pageX - slider.offsetLeft;
                        scrollLeft = slider.scrollLeft;
                        cancelMomentumTracking();
                    });


                    slider.addEventListener('mouseleave', () => {
                        isDown = false;
                        slider.classList.remove('active');
                    });


                    slider.addEventListener('mouseup', () => {
                        isDown = false;
                        slider.classList.remove('active');
                        beginMomentumTracking();
                    });


                    slider.addEventListener('mousemove', (e) => {
                        if (!isDown) return;
                        e.preventDefault();
                        const x = e.pageX - slider.offsetLeft;
                        const walk = (x - startX) * 1.5; //scroll-fast
                        let prevScrollLeft = slider.scrollLeft;
                        slider.scrollLeft = scrollLeft - walk;
                        velX = slider.scrollLeft - prevScrollLeft;
                    });

                    // Momentum
                    let velX = 0;
                    let momentumID;

                    slider.addEventListener('wheel', (e) => {
                        cancelMomentumTracking();
                    }, { passive: true });

                    function beginMomentumTracking() {
                        cancelMomentumTracking();
                        momentumID = requestAnimationFrame(momentumLoop);
                    }
                    function cancelMomentumTracking() {
                        cancelAnimationFrame(momentumID);
                    }
                    function momentumLoop() {
                        slider.scrollLeft += velX;
                        velX *= 0.95;
                        if (Math.abs(velX) > 0.5) {
                            momentumID = requestAnimationFrame(momentumLoop);
                        }
                    }
                }
                //}
            }
            item.classList.add('-init');
        })
    }
}

function onLoadScrollToElement() {
    const url = window.location;
    setTimeout(() => {
        if (url.hash !== "" && url.hash.includes("#")) {
            const selector = url.hash;
            const target = document.querySelector(selector);
            if (target !== undefined) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

    }, 500)

}